import React from "react";
import { getCardBodyContent } from "@qlik/qlik/src/lib/util/helpers";
import { getSpacingClassName } from "@qlik/qlik/src/lib/util/spacing";
import * as styles from "./styles.module.css";

/**
 * TableDesign component.
 * Renders a table of content with title, body and cta.
 * @param {Object} data - The component props.
 */
const TableDesign = ({ data }) => {
    const { additionalConfiguration, cardItem, customId } = data || {};
    const { title } = cardItem ?? {};
    const bodyContent = getCardBodyContent(cardItem);
    const additionalConfigurationClass = getSpacingClassName(additionalConfiguration);

    // Render the TableDesign component
    return (
        <section className={`table-design ${additionalConfigurationClass} ${styles.tableDesignSection}`} id={customId}>
            <div className="container">
                <div className="col">
                    {title && <h2 className="text-center mb-20">{title}</h2>}
                    <div>{bodyContent}</div>
                </div>
            </div>
        </section>
    );
};

export default TableDesign;
